import TYPES from './types';
import {truckTypes, sortTypes} from '~/components/CapacityRatio/types'



const init = () => {
  return {
    error: false,
    loading: true,
    list: [],
    filter: truckTypes.FLATBED,
    sort: sortTypes.STATE,
  };
};



const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.RATIO_GET: {
      if(action.pending) {
        return {
          ...state,
          loading: true,
          list: []
        }
      }
      if(action.error) {
        return {
          ...state,
          loading: false,
          error: true,
          list: []
        }
      }
      return {
        ...state,
        loading: false,
        error: false,
        list: action.payload.data.list
      }
    }
    case TYPES.RATIO_FILTER: {
      return {
        ...state,
        filter: action.payload,
        sort: sortTypes.STATE,
      }
    }
    case TYPES.RATIO_SORT: {
      return {
        ...state,
        sort: action.payload
      }
    }
  return null;
  };
}

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/cityRatio/reducer.js